class DocumentCollection{
  public name:string;
  public id:string;
  public url:string;
  public isPicture:boolean = false;


  /**
   * コンストラクタ
   */
  constructor( name:string, id:string, url:string, isPicture:boolean ) {
    this.name = name;
    this.id = url;
    this.isPicture = isPicture;
    this.url = url;

  }
}
export default DocumentCollection;
